import Request from "../lib/request";

const baseUrl = process.env.REACT_APP_API_URL;

export const get = (sort) => {
  return Request({
    method: "get",
    url: `${baseUrl}/webNotifications?sort=${sort}`,
    needToken: true
  });
};

export const read = (notificationId) => {
  return Request({
    method: "get",
    url: baseUrl + "/notifications/" + notificationId + "/read",
    needToken: true,
  });
};

export const sendResponse = (notificationId) => {
  return Request({
    method: "get",
    url: baseUrl + "/feedbacks/" + notificationId,
    needToken: true,
  });
};

export const readFeedback = (notificationId) => {
  return Request({
    method: "get",
    url: baseUrl + "/feedback/" + notificationId + "/read",
    needToken: true,
  });
};